import { ICardViewThematicStrategy } from 'src/models/products.model';
import {
  Component,
  ElementRef,
  viewChild,
  EventEmitter,
  Input,
  Output,
  afterNextRender
} from '@angular/core';

@Component({
  selector: 'liberro-thematic-strategies-carousel',
  standalone: false,
  templateUrl: './liberro-thematic-strategies-carousel.component.html',
  styleUrl: './liberro-thematic-strategies-carousel.component.less'
})
export class LiberroThematicStrategiesCarouselComponent {
  @Input() public variant: 'list' | 'rotation' = 'rotation';
  @Input({ required: true }) public thematicStrategies!: ICardViewThematicStrategy[];
  @Output() public strategySelected = new EventEmitter<number>();
  private readonly swiperEl =
    viewChild.required<ElementRef<HTMLElement & { initialize: () => void }>>('swiperEl');

  public onStrategySelected(modelStrategyId: number): void {
    this.strategySelected.emit(modelStrategyId);
  }

  public constructor() {
    afterNextRender(() => {
      this.swiperEl().nativeElement.initialize();
    });
  }
}
